import {Tr} from "@/i18n/i18n";
import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {ArtifactReforgePanel} from "@/scenes.ui/artifact-reforge-panel";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {CreatureUtils} from "@/utils/creature-utils";
import {IntroPanel} from "@/scenes.ui/intro-panel";
import {Keys} from "@/constants/key";
import ArtifactStore from "@/store/artifact";
import PlayerStore from "@/store/player";
import {ScriptPlace} from "@/store/place/types";

@injectable()
export class MagicPlaceService {

    public openPlace(scene: Scene, canvas: HTMLCanvasElement, place: ScriptPlace, onVisitCallback: () => void): void {

        if (!place.used) {
            let ip: IntroPanel = new IntroPanel(scene, canvas, Tr('kuznitsa'), Tr('reforge'),
                Keys.ATLAS_PROFILE, Keys.IMG_ANVIL,
                Tr('zavidev.vas.kuznetsmag.ozhivljaetsja'),
                Tr('pravila.u.menja.takie.pri.perekovke.vibranniy'), () => {
                    ip.close();
                    this.openReforgePanel(scene, canvas, place, onVisitCallback);
                });
            ip.openAnimated();
        } else {
            this.openReforgePanel(scene, canvas, place, onVisitCallback);
        }
    }

    private openReforgePanel(scene: Scene, canvas: HTMLCanvasElement, place: ScriptPlace, onVisitCallback: () => void) {
        let artifactReforgePanel: ArtifactReforgePanel = new ArtifactReforgePanel(scene, canvas, CreatureUtils.findNonTemporalCreatures(PlayerStore.getPlayer().creatures),
            (artifactId: number, creatureId: number) => {
                ArtifactStore.refineArtifact(artifactId, creatureId, place.id).then(() => {
                    if (onVisitCallback != null) {
                        onVisitCallback();
                    }
                    new FeedbackPanel(scene, Tr('artefakt.uspeshno.perekovan'), undefined, true).show();
                });

            }, place.used);
        artifactReforgePanel.open();
    }

}
